module.exports = __webpack_public_path__ + "assets/img/configuration.c36fff80.svg";